<div class="ppl-mt20 p-4">
  <form nz-form nz-row [formGroup]="searchDiagnosisForm" class="ppl-p0">
      <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="code"
          class="ppl-form-label">Code
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
            <input nz-input formControlName="code" id="code"/>
        </nz-form-control>
      </nz-row>
      </nz-form-item>
      <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
        <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="description"
          class="ppl-form-label">Description
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
            <input nz-input formControlName="description" id="description"/>
        </nz-form-control>
      </nz-row>
      </nz-form-item>
      @if(errorMsg){
        <div style="color: red;">
          {{errorMsg}}
        </div>
      }
      <div class="custom-row" style="width: 100%">
        <ppl-button label="Search" type="submit" icon="fa fa-check-circle" [customClass]="'primary-button'"
          [iconPosition]="'right'" (handleClick)="onSearch()"></ppl-button>
      </div>
      </form>

      @if(diagnosisData){
    <div class="ppl-mt20">
      <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="diagnosisData"
      [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="true" [rowsToDisplay]="10"
      [loadPage]="true" (gridAction)="onAction($event)" [actionButtons]="actionButtons" [tableScrollable]="true"
      tableScrollHeight="250px">
  </ppl-list-table>
    </div>
      }
      </div>

  
